
export const flexSlider = [
  "/images/flexSlider/4.jpg",
  "/images/flexSlider/5.jpg",
  "/images/flexSlider/1.jpg",
  "/images/flexSlider/2.jpg",
]
